import React from "react"
import * as styles from "./animateImage.module.scss"
import classnames from "gpages/utils/classnames"

const AnimateImage = React.memo(({ images, mode, start, className }) => {
  return (
    <div
      className={classnames(
        styles.container,
        {
          [styles[mode]]: mode,
          [styles.start]: start,
        },
        className
      )}
    >
      <div className={styles.list}>
        {images.map((image, index) => {
          return (
            <div key={index}>
              <img src={image} alt="" className={styles.image} />
            </div>
          )
        })}
      </div>
    </div>
  )
})

AnimateImage.displayName = "AnimateImage"
export default AnimateImage
